import { iniciarMedicaoPagina } from './v2/medicao';
import { obterUsuario } from './v2/usuario';

// Termos de uso, política de privacidade e política de cookies v2 (protótipo v38). O sumário e os ids dos títulos vêm
// prontos do servidor; aqui: o sumário aberto e preso na lateral do computador, marcando a seção que está na tela, e,
// no celular, a aba da página aberta à vista (as abas rolam de lado).
const computador = window.matchMedia('(min-width: 960px)');
const semAnimacao = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
// Um id posto no editor com "%" solto faria o decodeURIComponent lançar e parar o script inteiro.
const idDo = link => {
    try {
        return decodeURIComponent(link.hash.slice(1));
    } catch {
        return link.hash.slice(1);
    }
};
// Ctrl/Cmd/Shift ou botão do meio abre em outra aba: não interceptar (o mesmo guarda do topo).
const cliqueComum = e => e.button === 0 && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey;
const sumario = document.querySelector('.inst__toc');
const detalhes = sumario?.querySelector('details');
const links = sumario ? [...sumario.querySelectorAll('a[href^="#"]')] : [];
const titulos = links.map(a => document.getElementById(idDo(a))).filter(Boolean);
let _segurar = null;
let _quadro = 0;

function _modoDoSumario() {
    if (!detalhes) {
        return;
    }
    // No computador o sumário fica aberto e fixo; no celular volta a ser o "Nesta página" que abre e fecha.
    detalhes.open = computador.matches;
    sumario.classList.toggle('is-fixo', computador.matches);
    const resumo = detalhes.querySelector('summary');
    if (computador.matches) {
        resumo.setAttribute('tabindex', '-1');
    } else {
        resumo.removeAttribute('tabindex');
    }
    _marcar();
}

function _alturaDoTopo() {
    return document.querySelector('.site-h')?.getBoundingClientRect().bottom || 0;
}

// A seção atual é o último título que já passou do topo (o clique no sumário vale por um instante, até a rolagem chegar).
function _marcar() {
    if (!computador.matches || !titulos.length) {
        return;
    }
    let atual = titulos[0].id;
    if (_segurar && Date.now() < _segurar.ate) {
        atual = _segurar.id;
    } else {
        const limite = _alturaDoTopo() + 32;
        titulos.forEach(t => {
            if (t.getBoundingClientRect().top <= limite) {
                atual = t.id;
            }
        });
    }
    let marcado = null;
    links.forEach(a => {
        const este = idDo(a) === atual;
        if (este) {
            a.setAttribute('aria-current', 'location');
            marcado = a;
        } else {
            a.removeAttribute('aria-current');
        }
    });
    // A lateral rola sozinha quando o sumário é mais alto que a janela: o item marcado fica à vista.
    const lateral = sumario.closest('.inst__side');
    if (marcado && lateral && lateral.scrollHeight > lateral.clientHeight) {
        const r = marcado.getBoundingClientRect();
        const l = lateral.getBoundingClientRect();
        if (r.top < l.top + 48) {
            lateral.scrollTop -= l.top + 48 - r.top;
        } else if (r.bottom > l.bottom - 8) {
            lateral.scrollTop += r.bottom - l.bottom + 8;
        }
    }
}

function _aoRolar() {
    if (_quadro) {
        return;
    }
    _quadro = requestAnimationFrame(() => {
        _quadro = 0;
        _marcar();
    });
}

function _irPara(link, e) {
    const titulo = document.getElementById(idDo(link));
    if (!titulo || !cliqueComum(e)) {
        return;
    }
    e.preventDefault();
    _segurar = { id: titulo.id, ate: Date.now() + 700 };
    setTimeout(_marcar, 720);
    if (!computador.matches && detalhes) {
        detalhes.open = false;
    }
    // O scroll-margin-top do título desconta o topo preso; o endereço ganha o #, para o link poder ser copiado.
    titulo.scrollIntoView({ behavior: semAnimacao() ? 'auto' : 'smooth', block: 'start' });
    history.replaceState(history.state, '', link.hash);
    titulo.focus({ preventScroll: true });
    _marcar();
}

function _abaAberta() {
    const abas = document.querySelector('.inst__tabs');
    const atual = abas?.querySelector('[aria-current]');
    if (abas && atual && abas.scrollWidth > abas.clientWidth) {
        abas.scrollLeft = Math.max(0, atual.offsetLeft - abas.offsetLeft - 24);
    }
}

// No computador o sumário é fixo: Enter ou Espaço no "Nesta página" não podem fechá-lo.
detalhes?.addEventListener('toggle', () => {
    if (computador.matches && !detalhes.open) {
        detalhes.open = true;
    }
});
sumario?.addEventListener('click', e => {
    const link = e.target.closest('a[href^="#"]');
    if (link) {
        _irPara(link, e);
    }
});
document.querySelector('[data-topo]')?.addEventListener('click', e => {
    if (!cliqueComum(e)) {
        return;
    }
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: semAnimacao() ? 'auto' : 'smooth' });
    document.getElementById('h1-legal')?.focus({ preventScroll: true });
});
// Gerador de currículo: o HTML é o mesmo para todos (cache público). Quem entrou troca o "Criar meu currículo" pelo
// "Baixar meu currículo" (o Meu currículo abre a janela de baixar no modelo escolhido) e vê quanto falta preencher.
function _geradorDeQuemEntrou(gerador, u) {
    if (!u?.logado) {
        return;
    }
    gerador.querySelectorAll('[data-ger-visitante]').forEach(el => {
        el.hidden = true;
    });
    gerador.querySelectorAll('[data-ger-logado]').forEach(el => {
        el.hidden = false;
    });
    gerador.querySelectorAll('[data-href-logado]').forEach(a => {
        a.href = a.dataset.hrefLogado;
        if (a.dataset.textoLogado) {
            a.textContent = a.dataset.textoLogado;
        }
    });
    const completar = gerador.querySelector('[data-ger-completar]');
    const pct = Number(u.curriculoProgresso);
    if (completar && Number.isFinite(pct) && pct < 100) {
        completar.querySelector('[data-ger-pct]').textContent = `(${completar.dataset.pctTexto.replace('{0}', pct)})`;
    } else if (completar) {
        completar.hidden = true;
    }
}

const gerador = document.querySelector('[data-ger]');
if (gerador) {
    obterUsuario().then(u => _geradorDeQuemEntrou(gerador, u)).catch(() => { /* sem a resposta, ficam os botões de quem não entrou */ });
}

window.addEventListener('scroll', _aoRolar, { passive: true });
computador.addEventListener('change', _modoDoSumario);

_modoDoSumario();
_abaAberta();
iniciarMedicaoPagina(gerador ? 'gerador' : 'pagina_estatica');
